import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=e5fa0b72&scoped=true"
import script from "./ColorPicker.vue?vue&type=script&lang=js"
export * from "./ColorPicker.vue?vue&type=script&lang=js"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=e5fa0b72&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5fa0b72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5fa0b72')) {
      api.createRecord('e5fa0b72', component.options)
    } else {
      api.reload('e5fa0b72', component.options)
    }
    module.hot.accept("./ColorPicker.vue?vue&type=template&id=e5fa0b72&scoped=true", function () {
      api.rerender('e5fa0b72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/ColorPicker.vue"
export default component.exports